import { Platform, StyleSheet } from 'react-native';

/** Above GlobalMenuModal drawer (1002) and most UI; below GlobalSnackbar (10005). */
const RULES_OVERLAY_Z = 10020;

export const worldCupRulesFromMenuOverlayStyles = StyleSheet.create({
  host: {
    ...StyleSheet.absoluteFillObject,
    zIndex: RULES_OVERLAY_Z,
    elevation: RULES_OVERLAY_Z,
    ...(Platform.OS === 'web' && {
      position: 'fixed' as never,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw' as never,
      height: 'var(--app-dvh, 100dvh)' as never,
      minHeight: 'var(--app-dvh, 100dvh)' as never,
    }),
  },
});
